import { track, type AnalyticsParams } from "@/lib/analytics/track";

const PENDING_CHECKOUT_KEY = "pending_checkout";

/** Keep the order details across the redirect to Stripe. */
export function rememberCheckout(params: AnalyticsParams): void {
  try {
    window.sessionStorage.setItem(PENDING_CHECKOUT_KEY, JSON.stringify(params));
  } catch {
    // Storage can be blocked. The purchase event is skipped, the payment is not.
  }
}

/** Send one purchase event when Stripe returns the buyer. A reload sends nothing. */
export function trackCheckoutPurchase(transactionId: string | null): void {
  try {
    const stored = window.sessionStorage.getItem(PENDING_CHECKOUT_KEY);
    if (!stored) return;
    window.sessionStorage.removeItem(PENDING_CHECKOUT_KEY);
    const params = JSON.parse(stored) as AnalyticsParams;
    track("purchase", { ...params, transaction_id: transactionId ?? undefined });
  } catch {
    // Analytics must never break the page a buyer lands on after paying.
  }
}
